import thLang from './entries/th-Th';
import enLang from './entries/en-US';

const AppLocale = {
  th: thLang,
  en: enLang,
};

export default AppLocale;
